"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _Folders = require("../selectors/Folders");

var _FolderFetch = require("../actions/FolderFetch");

var _FolderTree = _interopRequireDefault(require("../components/FolderTree"));

var mapStateToProps = function mapStateToProps(state, props) {
  return {
    tree: (0, _Folders.getFolderTree)(state),
    ancestors: (0, _Folders.getSelectedFolderAncestors)(state, props),
    folders: (0, _Folders.getFoldersById)(state)
  };
};

var mapDispatchToProps = {
  fetchFoldersByParentId: _FolderFetch.fetchFoldersByParentId
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FolderTree.default);

exports.default = _default;
module.exports = exports.default;